const Empty = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-empty"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-empty"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="m23.561.439c-.586-.586-1.535-.586-2.121,0l-2.806,2.806c-1.847-1.403-4.141-2.246-6.633-2.246C5.935,1,1,5.935,1,12c0,2.493.843,4.787,2.246,6.633l-2.806,2.806c-.586.586-.586,1.535,0,2.121.293.293.677.439,1.061.439s.768-.146,1.061-.439l2.806-2.806c1.847,1.403,4.141,2.246,6.633,2.246,6.065,0,11-4.935,11-11,0-2.493-.843-4.787-2.246-6.633l2.806-2.806c.586-.585.586-1.536,0-2.121ZM4,12c0-4.411,3.589-8,8-8,1.665,0,3.211.512,4.493,1.386l-11.107,11.107c-.874-1.282-1.386-2.828-1.386-4.493Zm16,0c0,4.411-3.589,8-8,8-1.665,0-3.211-.512-4.493-1.386l11.107-11.107c.874,1.282,1.386,2.828,1.386,4.493Z" />
    </svg>
  );
};

export default Empty;
